// extracted by mini-css-extract-plugin
export default {"btnpwd":"a96993426b"};